import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../pages/Main";
import AppBreadcrumbs from "./ui/AppBreadcrumbs";
import { fetchActiveProviders } from "../api/providerApi";
import { useNotify } from "../context/NotifyContext";
import { toMediaUrl } from "../utils/mediaUrl";

const ProviderSelectGrid = ({
  service,
  title,
  description,
  breadcrumbs,
  fallbackPath,
}) => {
  const navigate = useNavigate();
  const { notify } = useNotify();
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await fetchActiveProviders(service);
      if (cancelled) return;
      setLoading(false);
      if (!res.success) {
        notify(res.message || "Failed to load providers", "error");
        return;
      }
      setProviders(res.data?.providers || []);
    })();
    return () => {
      cancelled = true;
    };
  }, [notify, service]);

  const go = (provider) => {
    if (provider.userPath) {
      navigate(provider.userPath);
      return;
    }
    const version = provider.providerVersion || "v1";
    const code = String(provider.providerCode || "").toLowerCase();
    if (service === "PG_PAYOUT") {
      navigate(`/pg-payout/${version}`);
      return;
    }
    navigate(fallbackPath ? `${fallbackPath}/${code}` : `/${code}/${version}`);
  };

  return (
    <Main>
      <AppBreadcrumbs items={breadcrumbs} />
      <div className="ds-card mt-3">
        <h1 className="m-0 text-sm font-semibold">{title}</h1>
        <p className="mt-1 mb-0 text-xs text-[var(--text-muted)]">{description}</p>
      </div>
      {loading ? (
        <p className="mt-4 text-sm text-[var(--text-muted)]">Loading providers…</p>
      ) : providers.length === 0 ? (
        <p className="mt-4 text-sm text-[var(--error-color)]">
          No provider is currently active for this service.
        </p>
      ) : (
        <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {providers.map((provider) => {
            const image = toMediaUrl(provider.imageUrl);
            return (
              <button
                key={`${provider.providerCode}-${provider.providerVersion}-${provider.service}`}
                type="button"
                className="ds-card text-left hover:border-[var(--primary-color)]"
                onClick={() => go(provider)}
              >
                {image ? (
                  <img
                    src={image}
                    alt={provider?.service || "ezypayindImg"}
                    className="mb-2 h-8 w-auto max-w-[120px] object-contain"
                  />
                ) : null}
                <p className="m-0 text-sm font-semibold">
                  {provider.providerName}{" "}
                  {String(provider.providerVersion || "v1").toUpperCase()}
                </p>
                <p className="mb-0 mt-1 text-xs text-[var(--text-muted)]">
                  {/* {provider.providerCode} */}
                  Ezypayind
                   · {provider.service}
                </p>
              </button>
            );
          })}
        </div>
      )}
    </Main>
  );
};

export default ProviderSelectGrid;
